import { CurrencyPipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";

import { Constants, SessionStorageService } from "../_services";

@Pipe({ name: 'cad_currency' })
export class CadCurrencyPipe implements PipeTransform {
  constructor(private delegate: CurrencyPipe, private sessionState: SessionStorageService) {
  }

  transform(value: any, ...args: any[]): any {
    const locale = this.sessionState.getCurrentLanguageCode() === Constants.LanguageCodeFrench
      ? Constants.LocaleFrenchCanada
      : Constants.LocaleEnglishCanada;

    return this.delegate.transform(value, 'CAD', 'symbol-narrow', '1.2-4', locale);
  }
}



// WEBPACK FOOTER //
// ./src/app/global/cad-currency.pipe.ts